import * as React from "react";
import env from "../../env";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import * as ReactGA from "react-ga";

import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from "prop-types";
import classNames from "classnames";

import {
  AcknowledgeTerms,
  AddClient,
  AdminAdvisorDetail,
  AdminAdvisorList,
  AdminClientPortfolio,
  AdminCustodianList,
  AdminDashboard,
  AdminFees,
  AdvisorSettings,
  Dashboard,
  Education,
  Feed,
  HouseholdDetail,
  // Paperwork,
  Downloads,
  Portfolio,
  PortfolioRisk,
  PortfolioReturn,
  PortfolioSummary,
  UserCustodians,
  UserProfile,
  UserRepCodes,
  Welcome,
} from "..";

import DemoBanner from "../../components/DemoBanner";
import HostedQuikForm from "../../components/HostedQuikForm";
import DigitalOnboardingPage from "./components/DigitalOnboardingPage";

import {
  AddClientNavigation,
  AdminNavigation,
  DoNavigation,
  EducationNavigation,
  FloatingNavigation,
  PortfolioNavigation,
  UserNavigation,
} from "./components";

import { NoBDRepCodeAlert, VerifyCRD } from "../Notifications";
import { isBasicView } from "../../utilities/access";

const styles = (theme) => ({
  main: {
    position: "absolute",
    zIndex: 0,
    width: `calc(100% - ${
      theme.wbiComponent.staticNavigation.totalWidth +
      2 * theme.wbiComponent.cyContainer.basePadding
    }px)`,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      width: "calc(100% - 139px)",
    },
    [theme.breakpoints.down("lg")]: {
      width: "calc(100% - 149px)",
    },
    minHeight: 768,
    padding: theme.wbiComponent.cyContainer.basePadding,
    paddingRight:
      theme.wbiComponent.ctaController.totalWidth +
      theme.wbiComponent.cyContainer.basePadding,
    right: 0,
    boxSizing: "border-box",
    height: "100%",
    "@media not print": {
      background: theme.palette.grey[50],
    },
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&.staticNavHidden": {
      width: `calc(100% - 40px)`,
    },
    "&.staticNavHidden.mainNavClosed": {
      width: `calc(100% - 40px)`,
    },
    "&.staticNavHidden.mainNavOpened": {
      width: `calc(100% - ${
        theme.wbiComponent.staticNavigation.totalWidth +
        2 * theme.wbiComponent.cyContainer.basePadding
      }px)`,
      [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
        width: "calc(100% - 139px)",
      },
    },
    "&.mainNavOpened.do": {
      padding: 0,
    },
    "&.mainNavClosed.do": {
      padding: 0,
    },
    "&.mainNavClosed.do.isDemoMode": {
      height: "calc(100vh - 37px)",
    },
    "@media print": {
      width: "100%",
      padding: 20,
    },
  },
  backDrape: {
    background: `linear-gradient(-189deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 94%)`,
  },
  demoBanner: {},
});

const GatedRoute = ({
  classes,
  component: Component,
  gates,
  cProps,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      // IE doesn't support array.find
      const redirects = gates.filter((gate) => gate.condition);
      return redirects.length === 0 ? (
        <Component {...props} {...cProps} />
      ) : (
        <Redirect
          to={{
            pathname: redirects[0].redirect,
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

ReactGA.initialize(env.REACT_APP_GOOGLE_ANALYTICS_ID, { debug: false });

class Cy extends React.Component {
  componentDidMount() {
    this.unregisterHistoryListener = this.props.history.listen(
      (route, action) => {
        ReactGA.pageview(route.pathname);
        // console.info({ route, action }, "Component Route Change");
      }
    );
  }

  componentWillUnmount() {
    this.unregisterHistoryListener();
  }

  render() {
    const { classes, app, history, user, accessLevel } = this.props;
    // XXX: this is terrifying and I have no idea what it's supposed to do.
    if (!user.user.hasOwnProperty("video_watched")) {
      return null;
    }
    const adminGate = { condition: !user.user.isAdmin, redirect: "/Portal" };
    const videoGate = {
      condition: app.useVideoGate && !user.user.video_watched,
      redirect: "/Portal/education",
    };
    // const approvedUserGate = {
    //   condition: !user.user.approved,
    //   redirect: "/Portal",
    // };
    const termsGate = {
      condition: !user.user.termsAcknowledgedAt,
      redirect: "/Portal/acknowledge-terms-and-conditions",
    };
    const termsAcceptedGate = {
      condition: user.user.termsAcknowledgedAt,
      redirect: "/Portal",
    };
    const basicViewGate = {
      condition: isBasicView(user.user.userRole && user.user.userRole.accessLevel),
      redirect: "/Portal",
    };
    const termVideoGates = [termsGate, videoGate];

    const navComponents = {
      addClient: (
        <AddClientNavigation
          pathname={this.props.location.pathname}
          open={app.activeSubNav}
        />
      ),
      admin: (
        <AdminNavigation
          pathname={this.props.location.pathname}
          search={this.props.location.search}
          open={app.activeSubNav}
        />
      ),
      portfolio: (
        <PortfolioNavigation
          pathname={this.props.location.pathname}
          open={app.activeSubNav}
        />
      ),
      do: (
        <DoNavigation
          pathname={this.props.location.pathname}
          open={app.activeSubNav}
        />
      ),
      education: (
        <EducationNavigation
          pathname={this.props.location.pathname}
          open={app.activeSubNav}
        />
      ),
      user: (
        <UserNavigation
          pathname={this.props.location.pathname}
          open={app.activeSubNav}
          accessLevel={accessLevel}
        />
      ),
    };

    return (
      <React.Fragment>
        {app.demoMode && (
          <React.Fragment>
            <DemoBanner light={true} />
            <NoBDRepCodeAlert />
          </React.Fragment>
        )}
        <FloatingNavigation
          mainNavOpened={app.mainNavOpened}
          history={history}
          accessLevel={accessLevel}
        />
        {app.activeSubNav && navComponents[app.activeSubNav]}

        <VerifyCRD />

        <main
          className={classNames(classes.main, {
            staticNavHidden: !app.activeSubNav,
            mainNavOpened: app.mainNavOpened,
            mainNavClosed: !app.mainNavOpened,
            isDemoMode: app.demoMode,
            [app.activeSubNav]: app.activeSubNav,
          })}
        >
          <GatedRoute
            exact
            path={`${this.props.match.path}/`}
            component={Dashboard}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/dashboard`}
            component={Dashboard}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/acknowledge-terms-and-conditions`}
            component={AcknowledgeTerms}
            gates={[termsAcceptedGate]}
          />
          <GatedRoute
            path={`${this.props.match.path}/education`}
            component={Education}
            gates={[termsGate]}
          />
          <GatedRoute
            path={`${this.props.match.path}/loss-simulator`}
            component={PortfolioRisk}
            gates={[termsGate]}
            cProps={{ demoMode: true }}
          />
          <GatedRoute
            path={`${this.props.match.path}/cy-intelligence`}
            component={Feed}
            gates={[termsGate]}
          />
          {/*<GatedRoute path={`${this.props.match.path}/paperwork`} component={Paperwork} gates={[termVideoGates, approvedUserGate]}/>*/}
          <GatedRoute
            path={`${this.props.match.path}/downloads`}
            component={Downloads}
            gates={[termsGate]}
          />

          <GatedRoute
            path={`${this.props.match.path}/start/:householdId?`}
            component={Welcome}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/new`}
            component={AddClient}
            gates={termVideoGates}
            cProps={{ clientInit: true }}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/onboard`}
            component={HostedQuikForm}
            gates={termVideoGates}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/household/:householdId`}
            component={HouseholdDetail}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/client`}
            component={AddClient}
            gates={[...termVideoGates, basicViewGate]}
            cProps={{ clientInit: false }}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/risk`}
            component={PortfolioRisk}
            gates={[...termVideoGates, basicViewGate]}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/rroreturn`}
            component={PortfolioReturn}
            gates={[...termVideoGates, basicViewGate]}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/portfolio/:portfolioId?`}
            component={Portfolio}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/summary/:portfolioId?`}
            component={PortfolioSummary}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/household/:householdId/onboard/:doSessionId`}
            component={DigitalOnboardingPage}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/user/profile`}
            component={UserProfile}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/user/advisorSettings`}
            component={AdvisorSettings}
            gates={termVideoGates}
          />
          <GatedRoute
            path={`${this.props.match.path}/user/custodians`}
            component={UserCustodians}
            gates={[...termVideoGates, basicViewGate]}
          />
          <GatedRoute
            path={`${this.props.match.path}/user/repCodes`}
            component={UserRepCodes}
            gates={[...termVideoGates, basicViewGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin`}
            component={AdminDashboard}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/custodians`}
            component={AdminCustodianList}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/advisor`}
            component={AdminAdvisorList}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/fees`}
            component={AdminFees}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/advisor/:id`}
            component={AdminAdvisorDetail}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/client/:id/portfolio`}
            component={AdminClientPortfolio}
            gates={[adminGate]}
          />

          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/household/:householdId`}
            component={HouseholdDetail}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/household/:householdId/portfolio/:portfolioId`}
            component={AdminClientPortfolio}
            gates={[adminGate]}
          />
          <GatedRoute
            exact
            path={`${this.props.match.path}/admin/household/:householdId/portfolio`}
            component={AdminClientPortfolio}
            gates={[adminGate]}
          />
        </main>
      </React.Fragment>
    );
  }
}

Cy.propTypes = {
  classes: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
    accessLevel: state.user.user.userRole && state.user.user.userRole.accessLevel ? state.user.user.userRole.accessLevel : 0,
    clients: state.client,
  };
};
export default withStyles(styles)(connect(mapStateToProps)(Cy));



// WEBPACK FOOTER //
// ./src/containers/Cy/index.jsx